export default "/assets/images/problem-solved-03.f6e9a3b9aa368f58.png";